import { DateTime } from 'luxon';
import i18next from 'i18next';

/**
 * Функция для получения из даты Luxon строки месяца и дня или «сегодня», «завтра», «в ночь с * на *»
 * @param date Luxon DateTime
 * @param timezone часовой пояс
 * @returns string
 */
export default function formatDateTimeToDayAndMonth(
  date: DateTime,
  timezone: string,
  timesOfDay?: string,
  locale = 'ru'
): string {
  let res = '';

  const now = DateTime.now().setZone(timezone);

  //если прогулка с 0 до 4 утра
  const dateHour = date.get('hour');
  if (dateHour >= 0 && dateHour <= 3 && timesOfDay === 'night') {
    //если больше 0 и меньше 4 утра следующего дня
    const monthNameStart = date
      .minus({ days: 1 })
      .setLocale(locale)
      .toFormat('MMMM');
    const monthNameEnd = date.setLocale(locale).toFormat('MMMM');

    if (monthNameStart !== monthNameEnd) {
      return `${i18next.t('on_the_night')} ${date
        .minus({ days: 1 })
        .toFormat('d')} ${monthNameStart} ${i18next.t('to')} ${date.toFormat(
        'd'
      )} ${monthNameEnd}`;
    }

    return `${i18next.t('on_the_night')} ${date
      .minus({ days: 1 })
      .toFormat('d')} ${i18next.t('to')} ${date.toFormat(
      'd'
    )} ${monthNameStart}`;
  }

  //если прогулка сегодня
  if (+date.startOf('day') === +now.startOf('day')) {
    return i18next.t('today');
  }

  //если прогулка завтра
  if (+date.startOf('day') === +now.startOf('day').plus({ day: 1 })) {
    return i18next.t('tomorrow');
  }

  //результат в виде «число месяц»
  res = date.toFormat('d') + ' ' + date.setLocale(locale).toFormat('MMMM');

  return res;
}
